"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var styles = {
  title: {
    fontSize: 24,
    color: 'text.primary',
    lineHeight: '32px',
    mr: 1
  },
  subTitle: {
    fontSize: 12,
    color: 'grey.main',
    lineHeight: '16px'
  }
};

var StepTitle = function StepTitle(_ref) {
  var title = _ref.title,
      subTitle = _ref.subTitle;
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    my: 2
  }, title && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    sx: styles.title
  }, title), subTitle && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    sx: styles.subTitle
  }, subTitle));
};

var _default = /*#__PURE__*/(0, _react.memo)(StepTitle);

exports.default = _default;